import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledBlockFinancialResult,
  StyledBlockPresentation,
  StyledGovernanceTab,
} from './GovernanceTab.styled'
import BlockWithDocuments from '../BlockWithDocuments/BlockWithDocuments'

const contentBlocEnum = Object.freeze({
  blocDocument: 'contentBlocWithDocuments',
  blocFinancial: 'componentFinancialResultsBloc',
})

const GovernanceTab = (props) => {
  const { blocsContent } = props.activeTab

  const blocs = blocsContent.map((bloc, index) => {
    if (bloc.sys.contentType.sys.id === contentBlocEnum.blocDocument) {
      return (
        <StyledBlockPresentation key={index}>
          <BlockWithDocuments
            documents={bloc.blocDocuments}
            text={bloc.textBloc}
            title={bloc.title}
          />
        </StyledBlockPresentation>
      )
    }
    if (bloc.sys.contentType.sys.id === contentBlocEnum.blocFinancial) {
      return <StyledBlockFinancialResult key={index} block={bloc} />
    }
  })

  return <StyledGovernanceTab>{blocs}</StyledGovernanceTab>
}

GovernanceTab.propTypes = {
  activeTab: PropTypes.object.isRequired,
}

export default GovernanceTab
